<template>
<div class="lockscreen-wrapper">
    <!-- Content Header (Page header) -->


    <!-- Main content -->
    <section class="content">

      <div class="row">
        <div class="col-md-9">

          <!-- Profile Image -->
          <div class="box box-primary">
            <div class="box-body box-profile">
              <img class="profile-user-img img-responsive img-circle" src="../../../static/img/avatar5.png" alt="User profile picture">
              </br>
              <h3 class="profile-username text-center">{{username}}</h3>
              <p class="text-muted text-center">{{roles}}</p>
              <hr>
              </br>
            <!--   <a href="#" class="btn btn-primary btn-block"><b>修改信息</b></a>
              </br> -->
              <a class="btn btn-primary btn-block" @click="handleEdit()"><b>修改密码</b></a>
            </div>
            <!-- /.box-body -->
          </div>
          <!-- /.box -->

          <!-- About Me Box -->
          <!--新增界面-->
          <el-dialog  v-model="addFormVisible" width="70%" top = "20%" :show-close= false >
            <div slot="title" class=" box-header with-border" >
              <h3 class="box-title">修改密码</h3>
            </div>
            </br>
            <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
            <el-form-item label="旧密码" prop="oldPassword" required>
              <el-input v-model="addForm.oldPassword" style="width:80%;"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword" required>
              <el-input type="password"  v-model="addForm.newPassword" auto-complete="off" style="width:80%;"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword" required>
              <el-input type="password"  v-model="addForm.confirmPassword" auto-complete="off" style="width:80%;"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click.native="addFormVisible = false">取消</el-button>
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
          </div>
        </el-dialog>
          <!-- /.box -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->

    </section>
    <!-- /.content -->
  </div>
  </template>
  <script>
import { webapi, HTTP} from '../../api/api';
export default {

  name: 'Profile',

  data() {
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (value === this.addForm.oldPassword) {
          callback(new Error('新密码不可与旧密码一致!'));
        } else {
          if (this.addForm.confirmPassword !== '') {
            this.$refs.addForm.validateField('confirmPassword');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.addForm.newPassword) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        addFormVisible: false,//新增界面是否显示
        addLoading: false,
        addFormRules: {
          oldPassword: [
            { required: true, message: '请输入旧密码', trigger: 'blur' }
          ],
          newPassword: [
            { validator: validatePass, trigger: 'blur' }
          ],
          confirmPassword: [
            { validator: validatePass2, trigger: 'blur'}
          ]
        },
        //新增界面数据
        addForm: {
          username:window.localStorage.getItem('user'),
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        },

        manufacturerName:"",
        hospitals:"",
        groupName:"",
        username:"",
        roles:window.localStorage.getItem('roles')== "ROLE_ADMIN"&&window.localStorage.getItem('user')== "admin" ? '管理员' :window.localStorage.getItem('roles')== "ROLE_ADMIN"&&window.localStorage.getItem('user')!= "admin" ? '操作员' : window.localStorage.getItem('roles')== "ROLE_USER" ? '用户':"未知",

      salesVisible: false,

    }
  },

  methods: {
    getCommonName(){
      let para = { username: window.localStorage.getItem('user') };
     webapi.post('/user/getCommonName',para).then((res) => {
        this.username = res.data.commonName
      }).catch(error => {
      })
    },
    handleEdit: function () {
        this.addFormVisible = true;
      },
    addSubmit: function () {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              webapi.post('/user/changePassword',para).then((res) => {

                this.addLoading = false;
                if(res.data=="errorpassword"){
                  this.$message({
                  message: '密码错误',
                  type: 'error'
                });
                }else if(res.data=="success"){
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });

              }
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getManufacturer();
              }).catch((error) => {
                this.addLoading = false;
                  this.$message.error(error.response.data['message']);
              });
          }
        });
      }
  },
  mounted() {
      // this.getCommonName();
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// Profile.vue?9d1cb4e4